<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshChange"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.room_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { getList, getDetail, add, update, remove } from "@/api/spcod/room";
import { mapGetters } from "vuex";
import * as dictService from "@/api/system/dictbiz";

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: "auto",
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        dialogClickModal: false,
        column: [
          {
            label: "名称",
            prop: "name",
            rules: [
              {
                required: true,
                message: "请输入名称",
                trigger: "blur",
              },
            ],
          },
          {
            label: "编号",
            prop: "code",
            rules: [
              {
                required: true,
                message: "请输入编号",
                trigger: "blur",
              },
            ],
          },
          {
            label: "房间面积",
            prop: "roomArea",
            rules: [
              {
                required: true,
                message: "请输入房间面积",
                trigger: "blur",
              },
            ],
          },
          {
            label: "装修情况",
            prop: "renovation",
            type: "select",
            dicUrl: dictService.getUrl("decoration"),
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            rules: [
              {
                required: true,
                message: "请输入装修情况",
                trigger: "blur",
              },
            ],
          },
          {
            label: "户型",
            prop: "roomLayout",
            rules: [
              {
                required: true,
                message: "请输入户型",
                trigger: "blur",
              },
            ],
          },
          {
            label: "户型图ID",
            prop: "layoutAttachment",
            rules: [
              {
                required: true,
                message: "请输入户型图ID",
                trigger: "blur",
              },
            ],
          },
          {
            label: "所属楼层ID",
            prop: "floorId",
            rules: [
              {
                required: true,
                message: "请输入所属楼层ID",
                trigger: "blur",
              },
            ],
          },
          {
            label: "所属楼宇ID",
            prop: "buildingId",
            rules: [
              {
                required: true,
                message: "请输入所属楼宇ID",
                trigger: "blur",
              },
            ],
          },
          {
            label: "付款方式",
            prop: "paymentType",
            rules: [
              {
                required: true,
                message: "请输入付款方式",
                trigger: "blur",
              },
            ],
          },
          {
            label: "房间图片列表",
            prop: "attachment",
            rules: [
              {
                required: true,
                message: "请输入房间图片列表",
                trigger: "blur",
              },
            ],
          },
          {
            label: "出租单价(元/m²/天)",
            prop: "rentalUnitPriceDay",
            rules: [
              {
                required: true,
                message: "请输入出租单价(元/m²/天)",
                trigger: "blur",
              },
            ],
          },
          {
            label: "房源类型",
            prop: "housingResourcesType",
            rules: [
              {
                required: true,
                message: "请输入房源类型",
                trigger: "blur",
              },
            ],
          },
          {
            label: "出租单价(元/月)",
            prop: "rentalUnitPriceMonth",
            rules: [
              {
                required: true,
                message: "请输入出租单价(元/月)",
                trigger: "blur",
              },
            ],
          },
          {
            label: "房间标签",
            prop: "label",
            rules: [
              {
                required: true,
                message: "请输入房间标签",
                trigger: "blur",
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.room_add, false),
        viewBtn: this.vaildData(this.permission.room_view, false),
        delBtn: this.vaildData(this.permission.room_delete, false),
        editBtn: this.vaildData(this.permission.room_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
  },
  methods: {
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          done();
        },
        (error) => {
          loading();
          window.console.log(error);
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          done();
        },
        (error) => {
          loading();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return remove(this.ids);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (["edit", "view"].includes(type)) {
        getDetail(this.form.id).then((res) => {
          this.form = res.data.data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad(page, params = {}) {
      this.loading = true;
      getList(
        page.currentPage,
        page.pageSize,
        Object.assign(params, this.query)
      ).then((res) => {
        const data = res.data.data;
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
        this.selectionClear();
      });
    },
  },
};
</script>

<style></style>
